module.exports = __webpack_public_path__ + "static/media/visa.e5cd062a.png";